import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const IN_VIEW_THRESHOLD = 0.5;
const IN_VIEW_MILLISECS = 1000;

export type OnItemImpressionType = (target: any, ...args: any) => void;

const useTrackImpression = (
    onItemImpression: OnItemImpressionType,
    ...onItemImpressionArgs: Array<any>
): [(node?: Element) => void, boolean] => {
    const [ref, inView, entry] = useInView({ threshold: IN_VIEW_THRESHOLD });
    const [inViewTimeoutId, setInViewTimeoutId] = useState(undefined);

    useEffect(() => {
        let timeoutId;
        if (inView) {
            if (inViewTimeoutId === undefined) {
                const callback = () => {
                    onItemImpression(entry.target, ...onItemImpressionArgs);
                };
                timeoutId = setTimeout(callback, IN_VIEW_MILLISECS); // assumes callback will still be valid when timeout occurs
                setInViewTimeoutId(timeoutId);
            }
        } else if (inViewTimeoutId !== undefined) {
            clearTimeout(inViewTimeoutId);
            setInViewTimeoutId(undefined);
        }

        return () => {
            // Clear timeout on unmount
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line, react-hooks/exhaustive-deps
    }, [inView, IN_VIEW_MILLISECS]); // Re-run effect if these things changes

    return [ref, inView];
};

export default useTrackImpression;
